import React, { Component,useEffect,useState } from 'react';
import Piechart from '../../common/piechart';
import Columnchart from '../../common/columnchart';
import Stackedchart from '../../common/stackedchart';
import Sparklineschart from '../../common/sparklineschart';
import { Link } from 'react-router-dom';
import {useLocation} from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Donutchart from '../../common/donutchart';
import Donutchart1 from '../../common/donutchart1';
import Donutchart2 from '../../common/donutchart2';
import Barchart from '../../common/barchart';
import Barchart1 from '../../common/barchart1';
import LineChart from '../../common/Linechart';
import LineChart1 from '../../common/Linechart1';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { API_BASE_URL } from "../../../config.js"; // or use process.env
import { APP_BASE_URL } from "../../../config.js";

import TopTile from "../../../components/HRMS/Dashboard/TopTile";
import BirthdayToday from "../../../components/HRMS/Dashboard/BirthdayToday";
import UpcomingBirthdays from "../../../components/HRMS/Dashboard/UpcomingBirthdays";
import WelcomeHeader from "../../../components/EmpDashboard.css";
import BirthdayCard from "./BirthdayCard";

// import BirthdayCard1 from "./BirthdayCard1";
// import BirthdayBanner from "./BirthdayBanner";

import BirthdayFlipCard from "./BirthdayFlipCard.jsx";
import WorkingAnniversary from "../../../components/HRMS/Dashboard/WorkingAnniversary"

// import happyBirthdayImg from "../../../assets/images/happybirthdayflipcard.png";






const EmployeeDasboard = (props) => {
	const { fixNavbar } = props;

	
	const location=useLocation();
	const history = useHistory();

	const [count, setCount] = useState(0);
  	// const [loading, setLoading] = useState(true);
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(true);
  	const [tiles, setTiles] = useState({
	name: "",
	emp_id:"",
	department_name:"",
    people: 0, total_ctc: 0,
    links: { employees: "/hr-employees", leave: "/Hr-leaves", timesheet: "/attendance" }
  });

  const flipcard=APP_BASE_URL+'/aah-api/uploads/assets/happybirthdayflipcard.png';


//   alert(flipcard);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/activeEmployeesCount`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
        setTiles(data);
      } catch (e) {
        console.error("dashboard summary failed:", e?.message || e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


   useEffect(() => {
    const token = localStorage.getItem("authToken");
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE_URL}/birthdaysToday`, {
          headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
        });
        setRows(data?.data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);


  const fmt = (n) => (n ?? 0).toLocaleString(); // format numbers like 8138095 -> 8,138,095


       
// 	 useEffect(() => {
//     const token = localStorage.getItem("authToken"); // remove if not needed
//     (async () => {
//       try {
//         const { data } = await axios.get(`${API_BASE_URL}/activeEmployeesCount`, {
//           headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
//         });
//         setCount(data?.count ?? 0);
//       } catch (e) {
//         console.error("active-count fetch failed:", e?.message || e);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);
  
	// const data = history.location.state.data;


	// if(!data) {
    //     return history.push('/login');
    // }


	

const now = new Date();
  const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "long" }).format(now);
  const day = new Intl.DateTimeFormat("en-GB", { day: "2-digit" }).format(now);
  const month = new Intl.DateTimeFormat("en-GB", { month: "long" }).format(now);
  const year = new Intl.DateTimeFormat("en-GB", { year: "numeric" }).format(now);


	




	return (
		<>
			<div>
				<div className={`section-body ${fixNavbar ? "marginTop" : ""} mt-3`}>
					<div className="container-fluid">

                        <div className="welcome-header">
      <h4 className="welcome-title">
        Welcome back, <span className="welcome-name">{tiles.name || "there"}</span>!
      </h4>
      <div className="welcome-date">
        Today is {weekday}, {day} {month} {year}
      </div>

      <hr className="welcome-divider" />
      <hr className="welcome-divider" />
    </div>


							



					</div>
				</div>



	 {tiles.dob_flag == 1 && (
//    <BirthdayCard
//   show={true}                 // set false to hide
//   userName={tiles.name}
//   employeeId={tiles.emp_id}
//   department={tiles.department_name}
//   // message="Custom message here 🎈"
//  />


<BirthdayFlipCard
  name={tiles.name}
  employeeId={tiles.emp_id}
  image="/assets/images/happybirthdayflipcard.png"
  message = "May your birthday bring smiles, happiness and many blessings. Happy Birthday! 🎉🎂"
  department={tiles.department_name}
/>
	 )} <br /><br/> 




{/* <BirthdayFlipCard
  name={tiles.name}
  employeeId={tiles.emp_id}
  image="/assets/images/happybirthdayflipcard.png"
  message = "May your birthday bring smiles, happiness and many blessings. Happy Birthday! 🎉🎂"
  department={tiles.department_name}
/> */}






               





				<div className="section-body">
					<div className="container-fluid">

						<div className="row clearfix">
				<div className="col-12">
					<UpcomingBirthdays days={7} />
				</div>
				</div>

						<div className="row clearfix">
				<div className="col-12">
					<BirthdayToday />
				</div>
				</div>




				<div className="row clearfix">
					<div className="col-12">
						<WorkingAnniversary />
					</div>
				</div>


				


					

					
						
						{/* <div className="row clearfix">
							<div className="col-12 col-sm-12">
								<div className="card">
									<div className="card-header">
										<h3 className="card-title">Project Summary</h3>
									</div>
									<div className="card-body">
										<div className="table-responsive">
											<table className="table table-hover table-striped text-nowrap table-vcenter mb-0">
												<thead>
													<tr>
														<th>#</th>
														<th>Client Name</th>
														<th>Team</th>
														<th>Project</th>
														<th>Project Cost</th>
														<th>Payment</th>
														<th>Status</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>#AD1245</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>Angular Admin</td>
														<td>$14,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#DF1937</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>Angular Admin</td>
														<td>$14,500</td>
														<td>Pending</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#YU8585</td>
														<td>Merri Diamond</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
															</ul>
														</td>
														<td>One page html Admin</td>
														<td>$500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-orange">Submit</span>
														</td>
													</tr>
													<tr>
														<td>#AD1245</td>
														<td>Sean Black</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
															</ul>
														</td>
														<td>Wordpress One page</td>
														<td>$1,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
													<tr>
														<td>#GH8596</td>
														<td>Allen Collins</td>
														<td>
															<ul className="list-unstyled team-info sm margin-0 w150">
																<li>
																	<img
																		src="/assets/images/xs/avatar1.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar2.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar3.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li>
																	<img
																		src="/assets/images/xs/avatar4.jpg"
																		alt="Avatar"
																	/>
																</li>
																<li className="ml-2">
																	<span>2+</span>
																</li>
															</ul>
														</td>
														<td>VueJs Application</td>
														<td>$9,500</td>
														<td>Done</td>
														<td>
															<span className="tag tag-success">Delivered</span>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</div>
		</>
	);

}
const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar
})

const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDasboard);